export const sliderNewsFormatting = (news: any) => {
    const formatedNews=[]
    for(let i=0; i<news.length; i+=4){
        formatedNews.push(news.slice(i, i+1));
        formatedNews.push(news.slice(i+1, i+4));
    }

    return formatedNews;
}